'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getSystem = require('@mx/util/get-system');

var system = getSystem.getSystem();
var instances = [];
function install(Vue) {
    Vue.directive('tap', { bind: bind, unbind: unbind });
}
function isAvailable(modifiers) {
    return modifiers.all || modifiers.press || system === 'ios';
}
function bind(node, directive) {
    var modifiers = directive.modifiers;
    if (isAvailable(modifiers)) {
        instances.push(new Tap(node, modifiers));
    }
}
function unbind(node, directive) {
    var modifiers = directive.modifiers;
    if (isAvailable(modifiers)) {
        instances.forEach(function (tap, index) {
            if (tap.node === node) {
                tap.handler(false);
                instances.splice(index, 1);
            }
        });
    }
}
var Tap = /** @class */ (function () {
    function Tap(node, modifiers) {
        var _this = this;
        this.start = function (e) {
            _this.stop(e);
            _this.moved = false;
            if (_this.triggerPress) {
                _this.pressTimer = window.setTimeout(function () {
                    if (!_this.moved) {
                        _this.pressTriggered = true;
                        _this.trigger('press');
                    }
                }, Tap.pressTime);
            }
            _this.coord = {
                x: e.touches[0].clientX,
                y: e.touches[0].clientY
            };
        };
        this.move = function (e) {
            _this.stop(e);
            _this.moved = _this.moved || Math.max(Math.abs(e.touches[0].clientX - _this.coord.x), Math.abs(e.touches[0].clientY - _this.coord.y)) > Tap.tapMove;
        };
        this.end = function (e) {
            _this.stop(e);
            e.cancelable && e.preventDefault && e.preventDefault();
            if (_this.pressTriggered) {
                _this.pressTriggered = false;
            }
            else {
                if (_this.triggerPress) {
                    window.clearTimeout(_this.pressTimer);
                }
                if (!_this.moved) {
                    _this.trigger('click');
                }
            }
        };
        this.node = node;
        this.triggerPress = modifiers.press;
        this.stopPropagation = modifiers.stop;
        this.handler(true);
    }
    Tap.prototype.handler = function (flag) {
        var action = flag ? 'addEventListener' : 'removeEventListener';
        this.node[action]('touchstart', this.start);
        this.node[action]('touchmove', this.move);
        this.node[action]('touchend', this.end);
        this.node[action]('touchcancel', this.end);
    };
    Tap.prototype.stop = function (e) {
        if (e && e.stopPropagation && this.stopPropagation) {
            e.stopPropagation();
        }
    };
    Tap.prototype.trigger = function (eventName) {
        var event;
        if ('CustomEvent' in window) {
            event = new CustomEvent(eventName);
        }
        else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, true, true, void 0);
        }
        this.node.dispatchEvent(event);
    };
    Tap.tapMove = 8;
    Tap.pressTime = 500;
    return Tap;
}());

exports.default = install;
exports.Tap = Tap;
